import React, { useState, useEffect } from "react";
import { makeStyles, TextField, Typography } from "@material-ui/core";
import { t } from "ttag";
import { BaseDialog } from '@coolremote/shared';
import { TwoFactorAuthDialogStyles } from "./TwoFactorAuthDialog.style";

interface TwoFactorAuthDialogProps {
  onCancel: () => void;
  onConfirm: (inputValue: string) => void;
  onInputChange?: (value: string) => void;
  onClose: () => void;
  title?: string;
  text?: string;
  errorText?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  open: boolean;
  align?: string;
}

const TwoFactorAuthDialog: React.FC<TwoFactorAuthDialogProps> = (props) => {
  const {
    onCancel,
    onConfirm,
    title = t`Confirmation with input`,
    text = t`Are you sure you want to proceed`,
    open,
    cancelLabel = t`Cancel`,
    confirmLabel = t`Yes`,
    onClose,
    errorText,
    onInputChange,
  } = props;

  const useStyles = makeStyles(TwoFactorAuthDialogStyles);
  const classes = useStyles();
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    if (!open) {
      setInputValue('');
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm(inputValue);
    setInputValue('');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onInputChange) {
      onInputChange(e.target.value);
    }
    setInputValue(e.target.value);
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      onCancel={onCancel}
      onConfirm={handleConfirm}
      title={title}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      confirmDisabled={!inputValue}
    >
      <p>{text}</p>
      <div className={classes.inputContainer}>
        <TextField
          className={classes.input}
          id="2FAcode"
          label={t`Code`}
          value={inputValue}
          onChange={handleInputChange}
          fullWidth
        />
        {errorText && (
          <Typography className={classes.errorText}>{errorText}</Typography>
        )}
      </div>
    </BaseDialog>
  );
};

export default TwoFactorAuthDialog;
